import {match, Pattern} from 'ts-pattern';

import i18n from '@dms/i18n';

const MINIMUM_VISIBLE_ACTIVE_TIME_MS = 0;
const MILLISECONDS_PER_MINUTE = 60_000;
const MILLISECONDS_PER_HOUR = 3_600_000;
const NO_REMAINING_MINUTES = 0;

export const formatEngagementActiveTime = (activeTimeMs: number): string | null =>
  match(activeTimeMs)
    .with(
      Pattern.when((value) => value <= MINIMUM_VISIBLE_ACTIVE_TIME_MS),
      () => null
    )
    .with(
      Pattern.when((value) => value < MILLISECONDS_PER_MINUTE),
      () => `<1 ${i18n.t('general.metric.min')}`
    )
    .with(
      Pattern.when((value) => value < MILLISECONDS_PER_HOUR),
      (value) => {
        const minutes = Math.floor(value / MILLISECONDS_PER_MINUTE);

        return `${minutes} ${i18n.t('general.metric.min')}`;
      }
    )
    .otherwise((value) => {
      const hours = Math.floor(value / MILLISECONDS_PER_HOUR);
      const minutes = Math.floor((value - hours * MILLISECONDS_PER_HOUR) / MILLISECONDS_PER_MINUTE);

      return match(minutes)
        .with(NO_REMAINING_MINUTES, () => `${hours} ${i18n.t('general.metric.h')}`)
        .otherwise(
          () => `${hours} ${i18n.t('general.metric.h')} ${minutes} ${i18n.t('general.metric.min')}`
        );
    });
